import { useState, useEffect } from "react";

export function useMissive() {
  const [conversationIds, setConversationIds] = useState<string[]>([]);

  useEffect(() => {
    if (typeof Missive === "undefined") {
      console.warn("Missive SDK not loaded");
      return;
    }

    Missive.on("change:conversations", setConversationIds);
  }, []);

  return conversationIds;
}
